export const Portions = ["C", "D", "D1", "T", "C1", "BE", "C1E", "CE", "D1E", "DE"];
